import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ClubServicesService } from '../../services/club-services.service';

@Component({
  selector: 'app-success-account-created',
  templateUrl: './success-account-created.component.html',
  styleUrls: ['./success-account-created.component.scss']
})
export class SuccessAccountCreatedComponent implements OnInit {

  currentUser: any;
  defaultImage = '../../../../assets/icons/Loading_icon.gif';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: Router,
    private dialogRef: MatDialogRef<SuccessAccountCreatedComponent>,
    private spinner: SpinnerVisibilityService,
    private clubServ: ClubServicesService
  ) { }

  ngOnInit(): void {
  }

  okBtnClick() {
    try {

      console.log(this.route.url)
      // this.route.navigate(['/club_dashboard'])
      this.currentUser = localStorage.getItem("currentUser");
      this.currentUser = JSON.parse(this.currentUser)
      console.log(this.currentUser.userType)
      this.route.navigate(['/restaurant_dash/upcoming_orders'])
      this.route.navigateByUrl('/restaurant_dash/upcoming_orders', { skipLocationChange: true }).then(() => {
        // window.location.href = "/restaurant_dash/new_orders"
        window.location.href = "/restaurant_dash/upcoming_orders"
        this.dialogRef.close();
      });
    }
    catch (e) { }
  }

  EventAddClick() {
    this.route.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
      this.route.navigate(["/organization_dash"])
      this.dialogRef.close();
    });
  }

  EventAddManageClick() {
    this.route.navigateByUrl('/manageEvents', { skipLocationChange: true }).then(() => {
      this.route.navigate(["/manageEvents"])
      this.dialogRef.close();
    });
  }







  reloadClick() {
    try {
      location.reload();
    }
    catch (e) { }
  }

}
